import { Modal, ModalBody, ModalCloseButton, ModalContent, ModalHeader, ModalOverlay, useDisclosure } from '@chakra-ui/react'
import { useEffect, useRef } from 'react'
import { AL_CREATE, defaultSelectData, useSelectedItemAlertContext } from '../../context/selectedItemAlertContext'
import EmailForm from './EmailForm'


const ModalEmailAdd = ({ data }) => {
    const { onClose, isOpen, onOpen } = useDisclosure()
    const { setItemData } = useSelectedItemAlertContext()

    const openModal = useRef()
    openModal.current = () => {
        if (data?.type === AL_CREATE) onOpen()
    }

    useEffect(() => {
        openModal.current()
    }, [data])

    const onCloseHandle = () => {
        setItemData(defaultSelectData)
        onClose()
    }

    return (
        <Modal isOpen={isOpen} onClose={onCloseHandle} size="4xl" motionPreset="slideInBottom">
            <ModalOverlay />
            <ModalContent>
                <ModalHeader>เพิ่มรูปแบบอีเมล</ModalHeader>
                <ModalCloseButton />
                <ModalBody>
                    <EmailForm close={onCloseHandle} mode={AL_CREATE} />
                </ModalBody>
            </ModalContent>
        </Modal>
    )
}

export default ModalEmailAdd
